import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import { CheckEmailView } from './CheckEmailView';
import { useRequestNewPasswordFormViewController } from './RequestNewPasswordViewController';

export const RequestNewPasswordForm = () => {
  const { uiState, actions } = useRequestNewPasswordFormViewController();

  if (uiState.isEmailSubmitted) {
    return <CheckEmailView email={uiState.email} />;
  }

  return (
    <Box
      sx={{
        height: '100vh',
        bgcolor: 'grey.100',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        pt: { xs: 4, sm: 8 },
      }}
    >
      <Paper
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 2,
          maxWidth: '430px',
          width: '100%',
          mt: { xs: 5, sm: 10 },
          mx: { xs: 2, sm: 0 },
        }}
      >
        <Typography variant="h4" sx={{ mb: 2 }}>
          Restablece tu contraseña
        </Typography>
        <Box>
          Introduce tu correo electrónico y te enviaremos un enlace para que
          restablezcas tu contraseña.
        </Box>
        <TextField
          fullWidth
          label="Correo electrónico"
          type="email"
          variant="outlined"
          margin="normal"
          value={uiState.email}
          onChange={(e) => actions.onEmailChanged(e.target.value)}
        />
        <Button
          variant="contained"
          fullWidth
          sx={{ mt: 2 }}
          onClick={actions.handleSubmit}
          disabled={uiState.isDisabled}
        >
          Enviar
        </Button>
      </Paper>
    </Box>
  );
};
